import { useQuery } from '@tanstack/react-query';
import { getProdSupabaseClient } from '@/lib/supabase/client';
import { isInternalTenant } from '@/lib/supabase/tenantScoping';
import { useCurrentTenantId } from '@/contexts/TenantContext';

/** Internal (demo) tenants: dealer settings are read-only (no canonical dealer ids). */
export function useIsInternalTenant() {
  const tenantId = useCurrentTenantId();
  const { data } = useQuery({
    queryKey: ['tenant', 'isInternal', tenantId],
    queryFn: () => isInternalTenant(getProdSupabaseClient(), tenantId ?? ''),
    enabled: !!tenantId,
    staleTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false
  });
  return data === true;
}
